import { useModuleBaseMetadata, useModuleFederationContext } from '@msdk/common'
import { EntityMetadata, FormGroupDefinition, FormNode } from '@msdk/definitions'
import { styled, Tooltip } from '@msdk/ui'
import React, { ReactNode } from 'react'

import { GroupProps } from '../../../models/form/group-props'
import { resolveConfig, resolveItem } from '../../../utils'
import { ImportedComponentErrorBoundary } from '../../ImportedComponentBoundary'

const MissingComponent = styled('div')`
  width: 100%;
  height: 40px;
  background-color: red;
  color: white;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

interface Props {
  node: FormNode
  children?: ReactNode[]
}

export function CustomGroup({ node, children }: Props) {
  const groupDef = node.value.formDefinition as FormGroupDefinition
  const baseMetadata = useModuleBaseMetadata(groupDef.entityName, groupDef.formName) as EntityMetadata

  const modules = useModuleFederationContext()
  const msModule = modules.loadedModules[baseMetadata.msProvider]
  const ImportedComponent = resolveItem(msModule, groupDef.customUI)
  const config = resolveConfig(groupDef.config)

  const componentProps: GroupProps = {
    node,
    children,
    config,
  }

  return (
    <>
      {ImportedComponent && (
        <ImportedComponentErrorBoundary>
          <ImportedComponent {...componentProps} />
        </ImportedComponentErrorBoundary>
      )}
      {!ImportedComponent && (
        <Tooltip title={groupDef.customUI}>
          <MissingComponent>{groupDef.customUI}</MissingComponent>
        </Tooltip>
      )}
    </>
  )
}
